import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { authorities, authorityCoverage } from '../data/authorities';
export function Authorities() {
  return <section className="w-full bg-ink-100 py-20 lg:py-24" aria-labelledby="authorities-heading" data-id="element-13" data-mp="13lbrve6jtgqd">
      <div className="mx-auto max-w-content px-6" data-id="element-14" data-mp="17mxc5klewxal">
        <div className="max-w-2xl" data-id="element-15" data-mp="1ck5r7cb9kl7m">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-flare-600" data-id="element-16" data-mp="1cl76xu385vvo">
            Autoridad regulatoria
          </p>
          <h2 id="authorities-heading" className="mt-3 text-3xl font-black leading-tight tracking-tight text-ink-950 sm:text-4xl" data-id="element-17" data-mp="1mhtrsivjwmxp">
            Diseñado para LATAM. Regulaciones oficiales 2026 de 5 países.
          </h2>
        </div>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-5" data-id="element-18" data-mp="1v93qsppcdb9s">
          {authorities.map(authority => <li key={authority.acronym} className="flex h-full flex-col rounded-lg border border-ink-950/10 bg-white p-5" data-id="element-19" data-mp="20at2m7ke1syx">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-20" data-mp="258upz4oukeg7">
                {authority.flag}
              </span>
              <span className="mt-3 text-lg font-black tracking-tight text-ink-950" data-id="element-21" data-mp="1um9qu9aptz2">
                {authority.acronym}
              </span>
              <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-flare-600" data-id="element-22" data-mp="3tz7y0t7clnqh">
                {authority.country}
              </span>
              <p className="mt-3 text-[13px] leading-snug text-ink-600" data-id="element-23" data-mp="pk70hzboxviw">{authority.name}</p>
              <p className="mt-auto flex items-center gap-1.5 pt-4 text-[11px] font-bold uppercase tracking-wide text-ink-500" data-id="element-24" data-mp="lilijzkaur1u">
                <ShieldCheckIcon className="h-4 w-4 text-flare-600" aria-hidden="true" data-id="element-25" data-mp="gr3h7aed6ogc" />
                Verificado
              </p>
            </li>)}
        </ul>

        <div className="mt-10 grid gap-8 lg:grid-cols-[1.3fr_1fr] lg:items-start" data-id="element-26" data-mp="bqza2azcj62s">
          <div data-id="element-27" data-mp="199in2r9rmm32">
            <p className="text-[15px] leading-relaxed text-ink-600" data-id="element-28" data-mp="19a0rib6l06m2">
              Drone Commander NO es un material genérico de Estados Unidos o España adaptado a LATAM.
              Fue escrito específicamente para la realidad regulatoria de Latinoamérica en 2026.
            </p>
          </div>
          <div className="rounded-lg border border-ink-950/10 bg-white p-6" data-id="element-29" data-mp="1senco35lvhdy">
            <h3 className="text-[11px] font-bold uppercase tracking-[0.16em] text-ink-500" data-id="element-30" data-mp="1el5v2nwhceqk">
              Cada tomo incluye análisis país-específico
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-31" data-mp="14m6u7rhyhne4">
              {authorityCoverage.map(item => <li key={item} className="flex items-start gap-2 text-sm leading-snug text-ink-700" data-id="element-32" data-mp="19m1j5pi682wj">
                  <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-flare-600" aria-hidden="true" data-id="element-33" data-mp="vn1wgne7xy30" />
                  <span data-id="element-34" data-mp="zndfxwuuhscw">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}